/**
 * This service calls the FileStore API and updates the store on successful execution
 */
import * as fileStoreApi from './FileStoreApi'
import { useFileStoreStore } from '@/features/filestore/FileStore.store'
import { EventBus } from '@/eventbus/EventBus'

function triggerErrorDialog(title, message) {
  EventBus.emit('fileStoreErrorDialog', {
    title: title,
    message: message
  })
}

const addFolder = (parentId, name) => {
  const fileStore = useFileStoreStore()
  return new Promise((resolve, reject) => {
    fileStoreApi
      .addFolder(parentId, name)
      .then((folder) => {
        fileStore.addFolder(folder)
        resolve(folder)
      })
      .catch((error) => {
        const message = error || 'Map bestaat al'
        triggerErrorDialog('Map aanmaken mislukt', message)
        reject(error)
      })
  })
}

const trashFolder = (folder) => {
  const fileStore = useFileStoreStore()
  fileStoreApi
    .trashFolder(folder.folderId)
    .then(() => {
      fileStore.trashFolder(folder.folderId)
    })
    .catch(() => triggerErrorDialog('Map verwijderen mislukt'))
}

const trashFiles = (fileIds) => {
  const fileStore = useFileStoreStore()
  fileStoreApi
    .trashFiles(fileIds)
    .then(() => {
      fileIds.forEach((fileId) => fileStore.trashFile(fileId))
    })
    .catch(() => triggerErrorDialog('Bestanden verwijderen mislukt'))
}

const addArchive = async (archiveName, billingAddressId) => {
  const fileStore = useFileStoreStore()
  await fileStoreApi.updateSetting({ terms: { fileStore201904: true } })

  const archive = await fileStoreApi.addArchive(archiveName, billingAddressId)

  await fileStore.refreshArchives()
  await fileStore.refreshFolders()

  return archive
}

const restoreFile = (file) => {
  const fileStore = useFileStoreStore()
  if (file.type === 'file') {
    fileStoreApi
      .restoreFile(file.id)
      .then(() => {})
      .catch(() => triggerErrorDialog('Bestand terugplaatsen mislukt'))
  } else {
    fileStoreApi
      .restoreFolder(file.id)
      .then(() => {
        fileStore.refreshFolders()
      })
      .catch(() => triggerErrorDialog('Map terugplaatsen mislukt'))
  }
}

const deleteArchive = (archive) => {
  const fileStore = useFileStoreStore()
  fileStoreApi
    .deleteArchive(archive)
    .then(async () => {
      await fileStore.refreshArchives()
      await fileStore.refreshFolders()
    })
    .catch(() => triggerErrorDialog('Verwijderen archief mislukt'))
}

export {
  addFolder,
  trashFolder,
  trashFiles,
  restoreFile,
  addArchive,
  deleteArchive
}
